import {Info} from "react-feather";
import {useAppDispatch} from "hooks";
import {Container, Grid} from "./styled";
import {CreditModel, HeadCell} from "interfaces";
import {PointOfSaleOutlined} from "@mui/icons-material";
import {updatePaymentStatus} from "global/slices/payments/thunks";
import {Column, Header, Row, Select, Typography} from "components";
import {PAYMENT_LIST_OPTION, PAYMENT_STATUS_ENUM_COLORS} from "utils";
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
} from "@mui/material";

interface CreditInfoProps {
  credit: CreditModel;
}

export const headCells: readonly HeadCell[] = [
  {
    id: "date",
    disablePadding: true,
    label: "Fecha",
  },
  {
    id: "amount",
    disablePadding: false,
    label: "Monto",
  },
  {
    id: "status",
    disablePadding: false,
    label: "Estatus",
  },
];

export const CreditInfo: React.FC<CreditInfoProps> = ({credit}) => {
  const dispatch = useAppDispatch();
  const {finanzas, tipo_apoyo} = credit;
  const help = JSON.parse(tipo_apoyo || "{}");

  const helpType = help[0] ? help[0]?.apoyo : "";
  const helpOption = help[0] ? help[0]?.opcion : "";
  const {monto, cuota, metodo_pago, observacion, payment_reports} = finanzas;
  return (
    <Container>
      <Column>
        <Header icon={Info} children="Información" />
        <Grid>
          <Column gap={0}>
            <Typography fontFamily="Rubik-Medium" fontSize={14}>
              Método de pago
            </Typography>
            <Typography fontSize={16}>{metodo_pago}</Typography>
          </Column>
          <Column gap={0}>
            <Typography fontFamily="Rubik-Medium" fontSize={14}>
              Cuota
            </Typography>
            <Typography fontSize={16}>{cuota} cuotas</Typography>
          </Column>
          <Column gap={0}>
            <Typography fontFamily="Rubik-Medium" fontSize={14}>
              Monto autorizado
            </Typography>
            <Typography fontSize={16}>{monto}</Typography>
          </Column>
          <Column gap={0}>
            <Typography fontFamily="Rubik-Medium" fontSize={14}>
              Tipo de apoyo
            </Typography>
            <Typography fontSize={16}>
              {helpType}
              {helpOption ? `, ${helpOption}` : ""}
            </Typography>
          </Column>
          <Column gap={0}>
            <Typography fontFamily="Rubik-Medium" fontSize={14}>
              Observación
            </Typography>
            <Typography fontSize={16}>{observacion}</Typography>
          </Column>
          <Column gap={0}>
            <Typography fontFamily="Rubik-Medium" fontSize={14}>
              Pagos reportados
            </Typography>
            <Typography fontSize={16}>
              {
                payment_reports.filter(({status}) => String(status) === "2")[
                  "length"
                ]
              }
            </Typography>
          </Column>
        </Grid>
      </Column>
      <Column gap={0}>
        <Header icon={PointOfSaleOutlined} children="Cuotas" />
        <TableContainer>
          <Table size="medium" sx={{minWidth: 450}}>
            <TableHead>
              <TableRow>
                {headCells.map(({id, disablePadding, label}) => (
                  <TableCell
                    key={id}
                    padding={disablePadding ? "none" : "normal"}
                  >
                    <Row gap={1}>
                      <Typography fontFamily="Rubik-Medium">{label}</Typography>
                    </Row>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {payment_reports.map(({id, date, amount, approved}, key) => {
                return (
                  <TableRow hover key={`${id}-${key}`} tabIndex={-1}>
                    <TableCell padding="none">
                      <Typography>{date}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>{amount.toLocaleString("US")}</Typography>
                    </TableCell>
                    <TableCell>
                      <Select
                        defaultValue={approved}
                        containerStyle={{maxWidth: 150}}
                        style={{
                          cursor: "pointer",
                          color: PAYMENT_STATUS_ENUM_COLORS[Number(approved)],
                          border: `2px solid ${
                            PAYMENT_STATUS_ENUM_COLORS[Number(approved)]
                          }`,
                        }}
                        options={PAYMENT_LIST_OPTION.map(({value, label}) => ({
                          value,
                          label,
                        }))}
                        onChange={({target}) => {
                          dispatch(
                            updatePaymentStatus({
                              id: Number(id),
                              approved: Number(target["value"]),
                            }),
                          );
                        }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Column>
    </Container>
  );
};
